import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component, HostBinding, HostListener, Input,
  OnChanges, SimpleChanges
} from '@angular/core';
import { TableSort } from '../../types/sort.type';
import { SortDirection } from '../../types/sort-direction.type';
import { PipesModule } from '../../../../pipes/pipes.module';
import { SortIconComponent } from '../sort-icon/sort-icon.component';
import { NgTemplateOutlet } from '@angular/common';

enum AriaSort {
  NONE = 'NONE',
  ASC = 'ASC',
  DESC = 'DESC'
}

@Component({
    selector: 'td-wb-table-header',
    templateUrl: 'table-header.component.html',
    styleUrls: ['table-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet, SortIconComponent, PipesModule]
})
export class TableHeaderComponent implements OnChanges {
  @Input() sort: () => void;
  @Input() sortDirections: Array<TableSort>;
  @Input() column: string;
  @HostBinding('class.td-wb-table-header--hover')
    hover: boolean = false;

  ariaSort: string = AriaSort.NONE;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
  }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    this.hover = true;
    this.changeDetectorRef.detectChanges();
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.hover = false;
    this.changeDetectorRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sortDirections !== undefined) {
      this.setAriaSort();
    }
  }

  isSortable(): boolean {
    return this.sort !== undefined;
  }

  onClick(event: Event): void {
    event.preventDefault();
    this.sort();
  }

  private setAriaSort(): void {
    if (this.sortDirections === undefined) {
      this.ariaSort = AriaSort.NONE;
    } else if (this.sortDirections[0]?.prop !== this.column) {
      this.ariaSort = AriaSort.NONE;
    } else {
      this.ariaSort = this.sortDirections[0]?.dir === SortDirection.ASC ? AriaSort.ASC : AriaSort.DESC;
    }
  }
}
